import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';

// Views
import Landing from './pages/Landing/Landing';
import Main from 'components/common/Main/Main';

// Services
import { AuthProvider } from './context/auth/authcontext';
import Signup from 'pages/Signup/Signup';

import ProtectedRoute from './components/protected-route/protected-route';
import LoginForm from 'components/features/Login/Login';

// Functional component with explicit React.FC type
const App: React.FC = () => {
  return (
    <Router>
      <AuthProvider>
        {/* <Navbar /> Common Navigation */}
        <Routes>
          <Route path='/' element={<Landing />} /> {/* Landing Page */}
          <Route path='/signup' element={<Signup />} />
          {/* Authentication Page */}
          <Route path='/login' element={<LoginForm />} />{' '}
          {/* Authentication Page */}
          <Route
            path='/main/*'
            element={
              <ProtectedRoute>
                <Main />
              </ProtectedRoute>
            }
          />
          {/* Add other routes as needed */}
        </Routes>
      </AuthProvider>
    </Router>
  );
};

export default App;
